import React, { useEffect, useState } from "react";
import MainNav from "./main-nav";
import { useTranslation } from "react-i18next";

const logo = "/img/logo.png";

const NavBar = () => {
  const { i18n } = useTranslation();
  const [country, setCountry] = useState(null);
  const browserLang = navigator.language || navigator.userLanguage; // e.g., "de-DE"

  useEffect(() => {
    fetch("https://ipapi.co/json/") //Free end point
      .then(res => res.json())
      .then(data => setCountry(data.country_code)) // "DE", "CH", etc.
      .catch(() => setCountry(null));
  }, []);

  // Show language dropdown only if NOT German OR NOT in DE/CH
  const showLangDropdown = !browserLang.startsWith("de") && country && !["DE", "CH"].includes(country);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className="nav-container mb-3">
      <nav className="navbar navbar-expand-md navbar-light bg-light">
        <div className="container main-nav d-flex align-items-center">
          {/* Logo */}
          <a style={{ width: "20%" }} className="col-2" href="/">
            <img className="logo-nav-bar" src={logo} alt="Logo" />
          </a>

          {/* Middle Navigation */}
          <MainNav />

          {/* Language Selector aligned to right */}
          {showLangDropdown && (
            <div className="ms-auto">
              <div className="dropdown">
                <button
                  className="btn btn-outline-warning btn-block dropdown-toggle"
                  id="langDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span style={{ color: "#FFC107" }}>🌐</span> {i18n.language.toUpperCase()}
                </button>
                <ul
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby="langDropdown"
                >
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => changeLanguage("en")}
                    >
                      English
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => changeLanguage("de")}
                    >
                      Deutsch
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
